import { STATUS } from '../enums/common'
import { ISlice } from '../interfaces/Slice'

export function setLoading<T extends ISlice>(state: T) {
  if ([STATUS.idle, STATUS.loaded].includes(state.status)) {
    return { ...state, status: STATUS.pending }
  }

  return state
}

export function setLoadedDone<T extends ISlice>(state: T) {
  return { ...state, status: STATUS.loaded }
}
